export default __webpack_public_path__ + "static/media/093-left-arrow-1.3ba84e6a.png";